// extracted by mini-css-extract-plugin
module.exports = {"main":"Summary_main__DPlYe","item":"Summary_item__T15UW"};